export default [
  {
    title: 'Administración',
    icon: 'setting',
    childrens: [
      {
        title: 'Proveedores',
        path: '/model/supplier',
      },
      {
        title: 'Perfiles',
        path: '/model/profile',
      },
      {
        title: 'Roles',
        path: '/model/role',
      }
    ],
  }
]


// WEBPACK FOOTER //
// ./src/containers/SideBar/menus/admin.js